import { Link } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import RichContent from '../common/RichContent';

const CERT_ICONS = [
  'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z',
  'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
  'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
  'M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z',
];

export default function TeacherCertificationsSection({ certifications = [], story }) {
  const hasCertifications = certifications.length > 0;
  const hasStory = Boolean(story?.text || story?.image);

  if (!hasCertifications && !hasStory) return null;

  return (
    <section className="bg-[#F3F0FF] px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
      <div className="mx-auto max-w-7xl">
        <h2 className="text-2xl font-bold text-[#1B1B1B] sm:text-[32px]">Certifications</h2>

        {hasCertifications && (
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {certifications.map((cert, index) => (
              <article
                key={cert.id}
                className="flex items-center gap-3 rounded-2xl bg-white px-4 py-4 shadow-[0_2px_14px_rgba(0,0,0,0.05)]"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#EDE8F5]">
                  <svg className="h-5 w-5 text-[#9369CC]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d={CERT_ICONS[index % CERT_ICONS.length]} />
                  </svg>
                </span>
                <p className="text-sm font-medium leading-snug text-[#1B1B1B]">{cert.label}</p>
              </article>
            ))}
          </div>
        )}

        {hasStory && (
          <div className={`grid grid-cols-1 items-center gap-8 ${hasCertifications ? 'mt-10' : 'mt-6'} ${story.image ? 'lg:grid-cols-2' : ''}`}>
            {story.image && (
              <div className="relative overflow-hidden rounded-2xl">
                <img src={story.image} alt="" className="h-[280px] w-full object-cover sm:h-[320px]" />
                {story.imageCaption && (
                  <div className="absolute bottom-4 left-4 max-w-[260px] rounded-lg bg-[#8B5E3C]/90 px-4 py-3 text-sm font-medium leading-snug text-white">
                    {story.imageCaption}
                  </div>
                )}
              </div>
            )}

            <div className="flex flex-col justify-between gap-6">
              {story.text && (
                <RichContent content={story.text} className="sm:text-base" />
              )}
              <div className="flex flex-wrap gap-4">
                <Link
                  to={ROUTES.CONTACT}
                  className="rounded-full border border-[#1B1B1B] bg-white px-8 py-2.5 text-sm font-semibold text-[#1B1B1B] transition hover:bg-[#F8F8F8]"
                >
                  Contact Us
                </Link>
                <Link
                  to={ROUTES.HOME}
                  className="rounded-full bg-[#9369CC] px-8 py-2.5 text-sm font-semibold text-white shadow-md transition hover:opacity-90"
                >
                  Explore
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
